import { Layout, theme, Typography } from "antd";
import MeetingRoomsTable from "../components/meetingrooms/MeetingRoomsTable";
import AddMeetingRoom from "../components/meetingrooms/AddMeetingRoom";

const { Content } = Layout;

const MeetingRooms = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout
      style={{
        marginLeft: 200,
      }}
    >
      <Content
        style={{
          margin: "24px 16px 0",
          overflow: "initial",
        }}
      >
        <div
          className="page-container"
          style={{
            background: colorBgContainer,
          }}
        >
          <Typography.Title level={5} className="titles-start">
            YENİ OTAQ
          </Typography.Title>
          <AddMeetingRoom />
          <Typography.Title level={5} className="titles-start">
            MÖVCUD OTAQLAR
          </Typography.Title>
          <MeetingRoomsTable />
        </div>
      </Content>
    </Layout>
  );
};

export default MeetingRooms;
